/**
 * HrSynthesisPrint — impression « People cost synthesis » : 4 pages, une par
 * onglet (Personnel cost · Expenses · Net paid · Social charges), avec les
 * mêmes colonnes / cellules / totaux que la page (module synthesisModel).
 */
import React, { useEffect, useMemo, useState } from 'react';
import { peopleCostSynthesis } from '../../../api/hr';
import {
  COLUMNS, VIEWS, VIEW_ORDER, renderCell, renderTotalCell, enrichRows, computeTotals,
} from '../synthesisModel';
import PrintReportHeader from './PrintReportHeader';
import '../HrPage.css';

export default function HrSynthesisPrint({ activeTenant, year, editedAt, onDataReady }) {
  const tenantId = activeTenant?.id;
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!tenantId) return;
    peopleCostSynthesis(tenantId, year, 'all')
      .then(r => { if (!r.error) setData(r.data || r); })
      .finally(() => onDataReady && onDataReady('synthesis'));
  }, [tenantId, year]); // eslint-disable-line

  const rows = useMemo(() => {
    const arr = enrichRows(data);
    arr.sort((a, b) => (a.last_name_sort || '').localeCompare(b.last_name_sort || ''));
    return arr;
  }, [data]);
  const totals = useMemo(() => computeTotals(rows), [rows]);

  return (
    <>
      {VIEW_ORDER.map(viewKey => {
        const view = VIEWS[viewKey];
        const allowed = new Set(view.cols);
        const cols = COLUMNS.filter(c => allowed.has(c.key));
        return (
          <section className="ppl-print__section" key={viewKey}>
            <PrintReportHeader category="People" title={view.label} year={year} tenant={activeTenant} editedAt={editedAt} />

            <table className="ppl-print__table">
              <caption>{view.label} · {rows.length} persons</caption>
              <thead>
                <tr>
                  {cols.map(c => (
                    <th key={c.key} className={c.numeric ? 'num nowrap' : undefined}>{c.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((r, idx) => (
                  <tr key={r.person_id} className={idx % 2 === 0 ? 'zebra' : ''}>
                    {cols.map(c => (
                      <React.Fragment key={c.key}>{renderCell(c, r)}</React.Fragment>
                    ))}
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  {cols.map(c => (
                    <React.Fragment key={c.key}>{renderTotalCell(c, totals)}</React.Fragment>
                  ))}
                </tr>
              </tfoot>
            </table>
          </section>
        );
      })}
    </>
  );
}
